import { Link } from 'react-router-dom';
import { collections } from '@/mocks/collections';
import SectionHeading from '@/components/base/SectionHeading';

export default function CollectionSidebar() {
  return (
    <section>
      <SectionHeading
        title="推荐专题"
        subtitle="围绕剧情与人物的主题合集"
        icon="ri-bookmark-3-line"
      />
      <div className="space-y-4">
        {collections.map((item) => (
          <Link
            key={item.id}
            to={item.href}
            className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 hover:border-primary-300 transition-colors"
          >
            <div className="relative w-24 h-[72px] rounded-md overflow-hidden shrink-0 bg-background-200">
              <img
                src={item.cover}
                alt={`推荐专题 ${item.title} 封面`}
                title={`${item.title} 女友的妈妈 推荐专题`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="min-w-0 flex flex-col justify-center">
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mt-1 line-clamp-2">
                {item.desc}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}